.styledCardContainer {
  position: relative;
  display: flex;
  width: 100%;
  height: 275px;
  flex-direction: column;
}

.styledCard {
  width: 100%;
  aspect-ratio: 1;
}

@media all and (--reefer-media-tablet-min) {
  .styledCardContainer {
    height: 350px;
  }
}
